import { render, staticRenderFns } from "./FormLivenessCheck.vue?vue&type=template&id=603c0157&scoped=true"
import script from "./FormLivenessCheck.vue?vue&type=script&lang=js"
export * from "./FormLivenessCheck.vue?vue&type=script&lang=js"
import style0 from "./FormLivenessCheck.vue?vue&type=style&index=0&id=603c0157&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603c0157",
  null
  
)

export default component.exports